import BidStrategiesService from '@/api/admin/bidStrategies.service'

export default {
  state: {
    table: {
      rows: [],
      searchTerm: '',
    },
    deleteBidStrategySubtype: {},
    adSubtypes: {},
    bidStrategies: {},
  },
  getters: {
    getBids: state => state.table,
    getDeleteBidStrategySubtype: state => state.deleteBidStrategySubtype,
    getAdSubtypes: state => state.adSubtypes,
    getBidStrategies: state => state.bidStrategies,
  },
  actions: {
    async getBids({ commit }) {
      const bids = await BidStrategiesService.getBids()
      commit('SET_BIDS', bids)
    },
  },
  mutations: {
    SET_BIDS(state, bids) {
      state.table.rows = bids.bidStategiesSubtypeMappingModels
      state.adSubtypes = bids.adSubtypes
      state.bidStrategies = bids.bidStrategies
    },
    SET_BID_STRATEGY_SUBTYPE_TO_DELETE(state, deleteBidStrategySubtype) {
      state.deleteBidStrategySubtype = deleteBidStrategySubtype
    },
  },
}
